import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class RemainingEstimateWithIcon extends Field {
  static subqueriesForModel() {
    return { remainingEstimate: ['text'] };
  }

  get title() {
    return 'Remaining estimate with icon';
  }

  exampleContents(): FieldContentsData {
    return {
      prefix: 'R',
      text: '3d',
    };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.remainingEstimate?.text) {
      return {
        prefix: 'R',
        text: record.remainingEstimate.text,
      };
    }

    return {};
  }
}
